module.exports = {"TXTWCL_Today":{"id":"TXTWCL_Today","defaultMessage":"Oggi"},"TXTWCL_Tomorrow":{"id":"TXTWCL_Tomorrow","defaultMessage":"Domani"}}